module.exports = __webpack_public_path__ + "static/media/6.6.ae3b6ef8.zip";